import {
  JsonElementSerializer_getInstance78doow9tocv6 as JsonElementSerializer_getInstance,
  JsonPrimitiveSerializer_getInstance4014jlq1v98x as JsonPrimitiveSerializer_getInstance,
  JsonObjectSerializer_getInstance3ny2swi7cl9nx as JsonObjectSerializer_getInstance,
  JsonArraySerializer_getInstance363y52pmd0j2p as JsonArraySerializer_getInstance,
  JsonNullSerializer_getInstance2y1iyo7s4gp2x as JsonNullSerializer_getInstance,
} from './JsonElementSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  printQuotedmgc3s3pgfors as printQuoted,
  toBooleanStrictOrNull2hf9surgqf5vr as toBooleanStrictOrNull,
} from './internal/StringOps.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Default_getInstancejyc493d440j2 as Default_getInstance } from './Json.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { StringCompanionObject_instance1v0ht40fz3tq0 as StringCompanionObject_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      q29() {
        return JsonElementSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var JsonElementClass;
function JsonElement() {
  if (JsonElementClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
    JsonElementClass = $;
  }
  return JsonElementClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var JsonPrimitiveClass;
function JsonPrimitive() {
  if (JsonPrimitiveClass === VOID) {
    class $ extends JsonElement() {
      toString() {
        return this.a2p();
      }
    }
    initMetadataForClass($, 'JsonPrimitive', VOID, VOID, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
    JsonPrimitiveClass = $;
  }
  return JsonPrimitiveClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.m3();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.n3();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  printQuoted(this_0, k);
  this_0.o1(_Char___init__impl__6a9atx(58));
  this_0.s1(v);
  return this_0.toString();
}
var JsonObjectClass;
function JsonObject() {
  if (JsonObjectClass === VOID) {
    class $ extends JsonElement() {
      constructor(content) {
        super();
        this.b2p_1 = content;
      }
      equals(other) {
        return equals(this.b2p_1, other);
      }
      hashCode() {
        return hashCode(this.b2p_1);
      }
      toString() {
        var tmp = this.b2p_1.l3();
        return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
      }
      n1() {
        return this.b2p_1.n1();
      }
      c2p(key) {
        return this.b2p_1.s4(key);
      }
      s4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.c2p((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      d2p(key) {
        return this.b2p_1.u4(key);
      }
      u4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.d2p((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      q2() {
        return this.b2p_1.q2();
      }
      v4() {
        return this.b2p_1.v4();
      }
      w4() {
        return this.b2p_1.w4();
      }
      l3() {
        return this.b2p_1.l3();
      }
    }
    initMetadataForClass($, 'JsonObject', VOID, VOID, [KtMap()], VOID, VOID, {0: JsonObjectSerializer_getInstance});
    JsonObjectClass = $;
  }
  return JsonObjectClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var JsonArrayClass;
function JsonArray() {
  if (JsonArrayClass === VOID) {
    class $ extends JsonElement() {
      constructor(content) {
        super();
        this.e2p_1 = content;
      }
      equals(other) {
        return equals(this.e2p_1, other);
      }
      hashCode() {
        return hashCode(this.e2p_1);
      }
      toString() {
        return joinToString(this.e2p_1, ',', '[', ']');
      }
      n1() {
        return this.e2p_1.n1();
      }
      f2p(element) {
        return this.e2p_1.t2(element);
      }
      t2(element) {
        if (!(element instanceof JsonElement()))
          return false;
        return this.f2p(element instanceof JsonElement() ? element : THROW_CCE());
      }
      p1() {
        return this.e2p_1.p1();
      }
      g2p(elements) {
        return this.e2p_1.q4(elements);
      }
      q4(elements) {
        return this.g2p(elements);
      }
      r2(index) {
        return this.e2p_1.r2(index);
      }
      h2p(element) {
        return this.e2p_1.r4(element);
      }
      r4(element) {
        if (!(element instanceof JsonElement()))
          return -1;
        return this.h2p(element instanceof JsonElement() ? element : THROW_CCE());
      }
      v2(index) {
        return this.e2p_1.v2(index);
      }
      b3(fromIndex, toIndex) {
        return this.e2p_1.b3(fromIndex, toIndex);
      }
      q2() {
        return this.e2p_1.q2();
      }
    }
    initMetadataForClass($, 'JsonArray', VOID, VOID, [KtList()], VOID, VOID, {0: JsonArraySerializer_getInstance});
    JsonArrayClass = $;
  }
  return JsonArrayClass;
}
var JsonNullClass;
function JsonNull() {
  if (JsonNullClass === VOID) {
    class $ extends JsonPrimitive() {
      constructor() {
        JsonNull_instance = null;
        super();
        JsonNull_instance = this;
        this.i2p_1 = 'null';
      }
      a2p() {
        return this.i2p_1;
      }
      q29() {
        return JsonNullSerializer_getInstance();
      }
      n20(typeParamsSerializers) {
        return this.q29();
      }
    }
    initMetadataForObject($, 'JsonNull', VOID, VOID, [SerializerFactory()], VOID, VOID, {0: JsonNullSerializer_getInstance});
    JsonNullClass = $;
  }
  return JsonNullClass;
}
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new (JsonNull())();
  return JsonNull_instance;
}
var JsonLiteralClass;
function JsonLiteral() {
  if (JsonLiteralClass === VOID) {
    class $ extends JsonPrimitive() {
      constructor(body, isString, coerceToInlineType) {
        coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
        super();
        this.j2p_1 = isString;
        this.k2p_1 = coerceToInlineType;
        this.l2p_1 = toString(body);
        if (!(this.k2p_1 == null)) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.k2p_1.x1p()) {
            var message = 'Failed requirement.';
            throw IllegalArgumentException().n2(toString(message));
          }
        }
      }
      a2p() {
        return this.l2p_1;
      }
      toString() {
        var tmp;
        if (this.j2p_1) {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().l1();
          printQuoted(this_0, this.l2p_1);
          tmp = this_0.toString();
        } else {
          tmp = this.l2p_1;
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof JsonLiteral()))
          THROW_CCE();
        if (!(this.j2p_1 === other.j2p_1))
          return false;
        if (!(this.l2p_1 === other.l2p_1))
          return false;
        return true;
      }
      hashCode() {
        var result = getBooleanHashCode(this.j2p_1);
        result = imul(31, result) + getStringHashCode(this.l2p_1) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'JsonLiteral');
    JsonLiteralClass = $;
  }
  return JsonLiteralClass;
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive() ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull()) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.a2p();
  }
  return tmp;
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull(_this__u8e3s4.a2p());
}
function parseLongImpl(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return StringJsonLexer(Default_getInstance(), _this__u8e3s4.a2p()).m2p();
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.a2p();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.a2p());
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, true);
}
function JsonPrimitive_1(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, false);
}
function JsonPrimitive_2(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, false);
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException().n2('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instancediiq8j4ljwru,
  JsonNull_getInstance as JsonNull_getInstancehlive1cpt4pr,
  JsonArray as JsonArray2urf8ey7u44sd,
  JsonElement as JsonElementf07o4p6p57al,
  JsonLiteral as JsonLiteral1u57id0qmqut7,
  JsonNull as JsonNull2liwjj96vm0w2,
  JsonObject as JsonObjectee06ihoeeiqj,
  JsonPrimitive_0 as JsonPrimitiveolttw629wj53,
  JsonPrimitive_1 as JsonPrimitive2fp8648nd60dn,
  JsonPrimitive_2 as JsonPrimitive1xkjzc5d7ihuv,
  JsonPrimitive as JsonPrimitive3ttzjh2ft5dnx,
  get_booleanOrNull as get_booleanOrNull376axlcpdhkmo,
  get_contentOrNull as get_contentOrNull35s97cgi8z9eo,
  get_double as get_double1785hcxaminy4,
  get_float as get_float1xtaobzj8js8m,
  get_jsonPrimitive as get_jsonPrimitivez17tyd5rw1ql,
  get_jsonUnquotedLiteralDescriptor as get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf,
  parseLongImpl as parseLongImpl2gkj8byk018b9,
};
//endregion

//# sourceMappingURL=JsonElement.mjs.map
